<template>
  <div class="mt-10 px-3 lg:px-6">
      <p><span class="font-bold">Quicks links: </span>access relevant information:</p>
      <div class="mt-6 grid gap-4 lg:gap-6" :class="[user.id == 1 ? 'lg:grid-cols-2' : 'lg:grid-cols-2']">
        <!-- <router-link class="link flex rounded py-4 justify-center items-center" to="/app/dashboard/approvals/vehicle">
          <img src="@/assets/images/approval.jpeg" alt="" class="">
          <p class="ml-4 font-bold">Vehicle Policy Approvals</p>
        </router-link> -->
        <router-link v-if="user.id == 1 || user.id == 2" class="link flex rounded py-4 justify-center items-center" to="/app/dashboard/vehicle">
          <img src="@/assets/images/approval.jpeg" alt="" class="">
          <p class="ml-4 font-bold">Vehicle Policy</p>
        </router-link>
        <!-- <router-link class="link flex rounded py-4 justify-center items-center" to="/app/dashboard/claims">
          <img src="@/assets/images/claims.jpeg" alt="" class="">
          <p class="ml-4 font-bold">Vehicle Claim Requests</p>
        </router-link>
        <router-link class="link flex rounded py-4 justify-center items-center" to="/app/dashboard/cancelrequests">
          <img src="@/assets/images/Temp.jpg" alt="" class="">
          <p class="ml-4 font-bold">Cancel Requests</p>
        </router-link> -->
        <router-link v-if="user.id == 1" class="link flex rounded py-4 justify-center items-center" to="/app/dashboard/approvals/health">
          <img src="@/assets/images/approval.jpeg" alt="" class="">
          <p class="ml-4 font-bold">Health Policies</p>
        </router-link>
        <router-link v-if="user.id == 2" class="link flex rounded py-4 justify-center items-center" to="">
          <img src="@/assets/images/approval.jpeg" alt="" class="">
          <p class="ml-4 font-bold">Home Content Policies</p>
        </router-link>

        <router-link v-if="user.id == 5" class="link flex rounded py-4 justify-center items-center" to="/app/dashboard/approvals/pet">
          <img src="@/assets/images/approval.jpeg" alt="" class="">
          <p class="ml-4 font-bold">Pet Policies</p>
        </router-link>
        <router-link v-if="user.id == 5" class="link flex rounded py-4 justify-center items-center" to="/app/dashboard/approvals/gadget">
          <img src="@/assets/images/approval.jpeg" alt="" class="">
          <p class="ml-4 font-bold">Gadget Policies</p>
        </router-link>
      </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  mounted(){
    console.log(this.user)
  }
}
</script>

<style scoped>
.link{
  box-shadow: 0px 20px 33px #00000029;
  margin-bottom: 40px;
}
.link img{
  width: 70px;
  height: 70px
}

</style>